import React from 'react';
import CustomImage from '../../../components/custom-image';

const CommunityInfra = () => {
  return (
    <div className="accordion-body">
       <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">20</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">200,000</p>
                  <p className="feature-benifit">people and</p>
                  <p className="bold-text blue-text">4,000+</p>
                  <p className="feature-benifit">families beneﬁt from these programmes</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
              Tube-wells/Open-wells/Borewells; Check-dams; Roads; Parks; Public education infrastructure; Community centres; Health centres; Village walls &
              gates; Renovation of sports complexes; Temples Irrigation channels; Drains; Bus stands; Street lights; Ponds; Public CCTV installations
              </p>
            </div>
          </div>
          <div className="right">
            <div className="img-wrapper">
              <CustomImage className="custom-image" imageName="community-infrastructure.jpg" alt="Community Infra" maxWidth="768" />
            </div>
          </div>
      </div>
    </div>
  );
};

export default CommunityInfra;
